import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import LogoutButton from './LogoutButton';

import { FiPhoneCall } from 'react-icons/fi';

// Import images
import aclogo from '../assets/images/aclogo.svg';
import pmedia from '../assets/images/polarismedia_logo_neg.svg';

const Header = () => {
	const { isLoggedIn, userRole, devMailMode, setDevMailMode } =
		useContext(AuthContext);

	return (
		<div className='main-header'>
			<div className='header-content'>
				<div className='ac-logo'>
					<img src={aclogo} alt='' />
				</div>
				<div className='menuItems'>
					<ul>
						
						<li><Link to='/'>Skjema</Link></li>
						
						{userRole === 'admin' || userRole === 'superAdmin' ? (<li><Link to='/admin'>Admin</Link></li>) : null}
						
						{userRole === 'superAdmin' && (
							<li className='dev-mail-toggle-item'>
								<button type='button' className={`dev-mail-toggle ${devMailMode ? 'active' : ''}`} onClick={() => setDevMailMode((prev) => !prev)}>
									Dev-mail: {devMailMode ? 'PÅ' : 'AV'}
								</button>
							</li>
						)}

					</ul>
				</div>
				<div className='userIcon'>
					<ul>
						{isLoggedIn ? (
							<>
								
								<li><Link to='/profile'>Profil</Link></li>
								
								<li><Link to='/orders'>Ordrer</Link></li>
								
								<li><LogoutButton /></li>
							</>
						) : (
							<li><Link to='/login'>Logg inn</Link></li>
						)}
					</ul>
				</div>
				<div className='alogo-section'>
					<div className='contact'>
						<h2>Janne Løvseth</h2>
						<div>
							<FiPhoneCall size='16' />{' '}
							<a href='tel:97715766'>977 15 766</a>
						</div>
					</div>
					<div className='border'></div>
					<img src={pmedia} alt='pmedia' />
				</div>
			</div>
		</div>
	);
};

export default Header;
